var map = {
	"./": 316,
	"./Prematch": 1138,
	"./Prematch.tsx": 1138,
	"./PrematchDeferred": 363,
	"./PrematchDeferred.tsx": 363,
	"./PrematchPage": 340,
	"./PrematchPage.dictionary": 216,
	"./PrematchPage.dictionary.json": 216,
	"./PrematchPage.explanation": 1140,
	"./PrematchPage.explanation.ts": 1140,
	"./PrematchPage.tsx": 340,
	"./actions": 47,
	"./actions/": 47,
	"./actions/index": 47,
	"./actions/index.ts": 47,
	"./components/Content": 1010,
	"./components/Content/": 1010,
	"./components/Content/Content": 980,
	"./components/Content/Content.tsx": 980,
	"./components/Content/index": 1010,
	"./components/Content/index.ts": 1010,
	"./components/MatchCenter": 906,
	"./components/MatchCenter/": 906,
	"./components/MatchCenter/MatchCenter": 880,
	"./components/MatchCenter/MatchCenter.module.scss": 936,
	"./components/MatchCenter/MatchCenter.tsx": 880,
	"./components/MatchCenter/index": 906,
	"./components/MatchCenter/index.ts": 906,
	"./components/Sport": 907,
	"./components/Sport/": 907,
	"./components/Sport/Sport": 937,
	"./components/Sport/Sport.module.scss": 1139,
	"./components/Sport/Sport.tsx": 937,
	"./components/Sport/Tournaments": 981,
	"./components/Sport/Tournaments/": 981,
	"./components/Sport/Tournaments/Grid": 1039,
	"./components/Sport/Tournaments/Grid.js": 1039,
	"./components/Sport/Tournaments/index": 981,
	"./components/Sport/Tournaments/index.jsx": 981,
	"./components/Sport/Unions": 982,
	"./components/Sport/Unions/": 982,
	"./components/Sport/Unions/Grid": 984,
	"./components/Sport/Unions/Grid.js": 984,
	"./components/Sport/Unions/Unions": 983,
	"./components/Sport/Unions/Unions.tsx": 983,
	"./components/Sport/Unions/UnionsVirtualizer": 985,
	"./components/Sport/Unions/UnionsVirtualizer.tsx": 985,
	"./components/Sport/Unions/Virtualizer": 986,
	"./components/Sport/Unions/Virtualizer.tsx": 986,
	"./components/Sport/Unions/index": 982,
	"./components/Sport/Unions/index.tsx": 982,
	"./components/Sport/index": 907,
	"./components/Sport/index.ts": 907,
	"./components/SportRedirect": 908,
	"./components/SportRedirect/": 908,
	"./components/SportRedirect/SportRedirect": 881,
	"./components/SportRedirect/SportRedirect.tsx": 881,
	"./components/SportRedirect/index": 908,
	"./components/SportRedirect/index.ts": 908,
	"./components/SportsGrid": 1040,
	"./components/SportsGrid/": 1040,
	"./components/SportsGrid/SportsGrid": 1049,
	"./components/SportsGrid/SportsGrid.module.scss": 1066,
	"./components/SportsGrid/SportsGrid.tsx": 1049,
	"./components/SportsGrid/components/TournamentTable/TournamentTable": 1041,
	"./components/SportsGrid/components/TournamentTable/TournamentTable.js": 1041,
	"./components/SportsGrid/index": 1040,
	"./components/SportsGrid/index.ts": 1040,
	"./hooks/useMetaContent": 362,
	"./hooks/useMetaContent.ts": 362,
	"./index": 316,
	"./index.ts": 316,
	"./reducer": 297,
	"./reducer/": 297,
	"./reducer/entities": 220,
	"./reducer/entities.ts": 220,
	"./reducer/index": 297,
	"./reducer/index.js": 297,
	"./reducer/prematchMatches": 374,
	"./reducer/prematchMatches.js": 374,
	"./reducer/presentation": 221,
	"./reducer/presentation.ts": 221,
	"./selectors/gridEntities": 157,
	"./selectors/gridEntities.ts": 157,
	"./selectors/gridPresentation": 838,
	"./selectors/gridPresentation.ts": 838,
	"./selectors/matchGridEntities": 286,
	"./selectors/matchGridEntities.ts": 286,
	"./selectors/matchGridPresentation": 1038,
	"./selectors/matchGridPresentation.ts": 1038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1257;
module.exports = webpackContext;